// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__-KMIn","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2CJuU","obliqueLine":"membershipbadge_obliqueLine__1A3Rj"};